import React, { useState } from 'react';
import { Slider } from 'antd';
import './atomics.css'; // Importe o CSS
import { useTranslation } from 'react-i18next';

// export const SliderPicker = () => {
//     const [level, setLevel] = useState(5);

//     const maxLevel = 5;

//     const handleSliderChange = (e) => {
//         setLevel(Number(e.target.value));
//     };

//     return (
//         <div className="pain-scale-slider-container">
//             <input
//                 type="range"
//                 min="1"
//                 max={maxLevel}
//                 value={level}
//                 onChange={handleSliderChange}
//                 className="pain-scale-slider"
//                 step="1"
//             />
//             <div className="pain-scale-labels">
//                 {[...Array(maxLevel).keys()].map((index) => (
//                     <div
//                         key={index}
//                         className={`label ${index + 1 <= level ? 'selected' : ''}`}
//                     >
//                         {index + 1}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// }





const SliderMarks = ({ count, value, onChange }) => {
    const { t } = useTranslation();
    const actualDate = new Date();

    function ultimos12Meses() {
        const meses = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun',
            'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];
    
        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth(); // Mês atual
        const mesesPassados = [];
    
        for (let i = 0; i < 12; i++) {
            const indexMes = (mesAtual - i + 12) % 12; // Garantir valores positivos
            mesesPassados.push({ name: meses[indexMes] });
        }
    
        return mesesPassados.map(x => {return x.name}).reverse(); // Inverter a ordem para que os meses mais recentes fiquem primeiro
    }

    function calcularAnoParaMesAtual(month) {
        const months = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
        const actualMonth = actualDate.getMonth();

        const monthIndex = months.findIndex(x => x === month);
        if(monthIndex > actualMonth){
            return actualDate.getFullYear() - 1;
        } else {
            return actualDate.getFullYear();
        }
    }

    const months = ultimos12Meses();

    return (
        <div className="slider-container">
            {Array.from({ length: count }, (_, i) => (
                <div
                    key={i}
                    className={`slider-mark ${value === months[i] ? 'active' : ''}`}
                    onClick={() => onChange(months[i], calcularAnoParaMesAtual(months[i]))}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <span>{t(months[i])}</span>
                    <span>{calcularAnoParaMesAtual(months[i])}</span>
                </div>
            ))}
        </div>
    );
};

const SliderPicker = ({ value, onChangePicker }) => {
    // const [value, setValue] = useState(1);
    return (
        <div className="custom-slider">
            <SliderMarks count={12} value={value} onChange={onChangePicker} />
        </div>
    );
};

export default SliderPicker;